export class GoogleWorkspaceGmailRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreOriginalLabels",
            "baseName": "restoreOriginalLabels",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceGmailRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
